import Head from 'next/head';

export enum HeadMetaTypeEnum {
  brokerLanding = 'brokerLanding',
}

interface CommonHeadMetasViewProps {
  metaType: HeadMetaTypeEnum;
  info?: {
    title?: string;
    description?: string;
    images?: string;
  };
}
const CommonHeadMetasView = (props: CommonHeadMetasViewProps) => {
  const { metaType, info } = props;
  return (
    <Head>
      {!!info && [HeadMetaTypeEnum.brokerLanding].includes(metaType) && (
        <>
          <meta content={info.description} key="og-description" />
          <meta name="twitter:description" content={info.description} />
        </>
      )}
      {!!info && [HeadMetaTypeEnum.brokerLanding].includes(metaType) && (
        <>
          <meta property="og:image" key="og-image" content={info.images} />
          <meta name="twitter:image" content={info.images} />
        </>
      )}
    </Head>
  );
};

export default CommonHeadMetasView;
